import React, { useState } from "react";
import { GamePageState } from "../../../common/utils/pageState";
import { CONDUCTED_STORY_GAME as GAME } from "../../../common/utils/games";
import { PageContainer } from "../../../common/components/page-container/PageContainer";
import ConductedStoryGamePlay from "./components/ConductedStoryGamePlay";
import ConductedStoryGameConfig from "./components/ConductedStoryGameConfig";
import { GameInfoComponent } from "../../../common/components/game-info/GameInfoComponent";
import { usePageTitle } from "../../../common/hooks";
import {IConductedStoryGameConfig, IGameDescription, Localised} from "../../../common/types";
import {getCurrentLang} from "../../../common/utils/lang";

const INITIAL_GAME_CONFIG: IConductedStoryGameConfig = {
    randomTopic: true,
    customTopic: "",
    selectedPlayerIds: []
};

const gameDescription:Localised<IGameDescription> = require("./description.json");

const ConductedStoryGamePage = () => {
    usePageTitle("games.conducted-story.name");

    const [page, setPage] = useState<GamePageState>(GamePageState.INFO);
    const [config, changeConfig] = useState<IConductedStoryGameConfig>(INITIAL_GAME_CONFIG);

    const pageChangeClick = (targetState: GamePageState) => () => {
        setPage(targetState);
    };

    const activeLang = getCurrentLang();
    const infoPage = <GameInfoComponent game={GAME} description={gameDescription[activeLang]} nextClick={pageChangeClick(GamePageState.CONFIG)} />

    const configPage = <ConductedStoryGameConfig
        nextToPlay={pageChangeClick(GamePageState.PLAY)}
        backToDetails={pageChangeClick(GamePageState.INFO)}
        config={config}
        changeConfig={changeConfig}
        />;

    const playPage = <ConductedStoryGamePlay
        backToDetails={pageChangeClick(GamePageState.INFO)}
        backToConfig={pageChangeClick(GamePageState.CONFIG)}
        config={config}
        />;

    const displayedPage = page === GamePageState.INFO ? infoPage : (page === GamePageState.CONFIG ? configPage : playPage);

    return (
        <PageContainer fixedHeaderFooter={true}>
            {displayedPage}
        </PageContainer>
    )
};

export default ConductedStoryGamePage;
